module.exports = __webpack_public_path__ + "img/case.5ef12173.svg";